import './SignUpForm.scss';


export default function SignUpForm() {

	return (
		<section className='signup'>
			<iframe className="iframe" src="https://bandsintown.com/artist/84892/email_signup_form?headerTextColor=rgba(255,255,255,1)&backgroundColor=rgba(0,0,0,0)&ctaBackgroundColor=rgba(0,180,179,1)&title=Join the Constellation Crew Newsletter&headerTextStyle=italic&headerText=Sign up to get the latest updates&font=Montserrat&ctaIcon=show&ctaBorderRadius=4px&ctaBorderWidth=2px&ctaBorderColor=rgba(0,180,179,1)&ctaFontColor=rgba(255,255,255,1)&alignment=center&emailInputField=show&ctaLabel=Subscribe&layout=wide&locale=en" width="100%" height="220px" title="newsletter-widget"></iframe>
		</section>
	)
}